import Vue from 'vue'

export function SET_FILTER (state, filter) {
  Vue.set(state, 'filter', filter)
}

export function RESET_FILTER (state) {
  state.filter = {}
}
